import React from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from '@/components/ui';
import { usePermissions } from '@/shared/hooks/usePermissions';
import { UserRole } from '@/shared/types/permissions.types';

interface FloatingChatButtonProps {
  onClick: () => void;
  isOpen?: boolean;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  badge?: number;
}

const FloatingChatButton: React.FC<FloatingChatButtonProps> = ({
  onClick,
  isOpen = false,
  position = 'bottom-right',
  badge,
}) => {
  const { checkRole } = usePermissions();
  const hasAccess = checkRole(UserRole.AGENCY_ADMIN);

  if (!hasAccess) {
    return null;
  }

  const getPositionClasses = () => {
    switch (position) {
      case 'bottom-right':
        return 'bottom-6 right-6';
      case 'bottom-left':
        return 'bottom-6 left-6';
      case 'top-right':
        return 'top-6 right-6';
      case 'top-left':
        return 'top-6 left-6';
      default:
        return 'bottom-6 right-6';
    }
  };

  return (
    <div
      className={`fixed ${getPositionClasses()} z-50 transition-all duration-300`}
    >
      <Button
        onClick={onClick}
        variant="primary"
        size="lg"
        className="h-14 w-14 p-0 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 relative flex items-center justify-center"
        aria-label={isOpen ? 'Cerrar chat' : 'Abrir chat'}
      >
        {isOpen ? (
          <X className="h-8 w-8" />
        ) : (
          <>
            <MessageCircle className="h-8 w-8" />
            {badge && badge > 0 && (
              <span className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                {badge > 9 ? '9+' : badge}
              </span>
            )}
          </>
        )}
      </Button>
    </div>
  );
};

export default FloatingChatButton;

